var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 40",
    style: {
      enableBackground: "new 0 0 32 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FD6E41;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 16.3,
    r: 15.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 10.4,
    cy: 9.6,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.6,
    cy: 11.3,
    r: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.6,22.7h-7.3c0-3.4,0-5.7,7.3-5.7c1.8,0,3.1,0.1,4.1,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.8,18.6H4.7c0-2.4,0-4.1,5.7-4.1c1.2,0,2.1,0.1,2.8,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.3,20.2v4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.8,22.7h4.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddGroup);
export default __webpack_public_path__ + "static/media/icon-add-group.20a8d8b4bb3ed63054506f4ebf72cda8.svg";
export { ForwardRef as ReactComponent };